import LoadingScreen from './LoadingScreen.jsx';

export default LoadingScreen;